export const BUNDLES_FILTER_FIELDS = [
  {
    type: 'text',
    name: 'title',
    label: 'Title',
    value: ''
  },
  {
    type: 'dropdown',
    name: 'published',
    label: 'Published',
    value: '',
    options: [
      {
        text: 'Yes',
        value: '1'
      },
      {
        text: 'No',
        value: '0'
      }
    ]
  }
];
